import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Dialog } from '@/components/ui/dialog';

interface Props {
  open: boolean;
  title: string;
  description: string;
  secret: string | null;
  onClose: () => void;
}

export function PlaintextSecretDialog({ open, title, description, secret, onClose }: Props) {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    if (!secret) return;
    try {
      await navigator.clipboard.writeText(secret);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1500);
    } catch {
      /* clipboard may be unavailable */
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={title}
      description={description}
      footer={
        <>
          <Button variant="outline" onClick={copy} disabled={!secret}>
            {copied ? 'Copied' : 'Copy'}
          </Button>
          <Button onClick={onClose}>Done</Button>
        </>
      }
    >
      <div className="space-y-2">
        <p className="text-xs uppercase tracking-wide text-muted-foreground">Save this — it won't be shown again</p>
        <pre className="overflow-x-auto rounded-md border bg-muted/50 px-3 py-2 font-mono text-xs">
          {secret ?? '—'}
        </pre>
      </div>
    </Dialog>
  );
}
